import { lazyView } from '../../app/lazyView.js';
import type { ViewComponent } from '../../app/Shell.js';

// Layar kelompok "data" → komponen (lihat features/PORTING.md). Dimuat terpisah (lazy).
export const views: Record<string, ViewComponent> = {
  toko: lazyView(() => import('./Toko.js')),
  produk: lazyView(() => import('./Produk.js')),
  master: lazyView(() => import('./DataMaster.js')),
  pengguna: lazyView(() => import('./Pengguna.js')),
  peran: lazyView(() => import('./Peran.js')),
  pengaturan: lazyView(() => import('./Pengaturan.js')),
  kunjungan: lazyView(() => import('./Kunjungan.js')),
};
